import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';

// Auth Pages
import Login from './pages/Login';
import Register from './pages/Register';

// Dashboard
import Dashboard from './pages/Dashboard';

// Client Pages
import ClientList from './pages/Clients/ClientList';
import AddClient from './pages/Clients/AddClient';
import EditClient from './pages/Clients/EditClient';

// Proposal Pages
import GenerateProposal from './pages/Proposals/GenerateProposal';
import ProposalHistory from './pages/Proposals/ProposalHistory';

// Quotation Pages
import GenerateQuotation from './pages/Quotations/GenerateQuotation';
import QuotationHistory from './pages/Quotations/QuotationHistory';

// Settings Pages
import CompanySettings from './pages/Settings/CompanySettings';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          {/* Protected Routes */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <div className="app-container">
                  <Navbar />
                  <Container fluid className="p-0">
                    <Row className="g-0">
                      <Col md={2} className="d-none d-md-block">
                        <Sidebar />
                      </Col>
                      <Col md={10}>
                        <Routes>
                          <Route path="/" element={<Dashboard />} />
                          <Route path="/dashboard" element={<Dashboard />} />
                          
                          {/* Client Routes */}
                          <Route path="/clients" element={<ClientList />} />
                          <Route path="/clients/add" element={<AddClient />} />
                          <Route path="/clients/edit/:id" element={<EditClient />} />
                          
                          {/* Proposal Routes */}
                          <Route path="/proposals" element={<ProposalHistory />} />
                          <Route path="/proposals/generate" element={<GenerateProposal />} />
                          
                          {/* Quotation Routes */}
                          <Route path="/quotations" element={<QuotationHistory />} />
                          <Route path="/quotations/generate" element={<GenerateQuotation />} />
                          
                          {/* Settings Routes */}
                          <Route path="/settings" element={<CompanySettings />} />
                          
                          {/* Redirect unknown routes */}
                          <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
